import { render, staticRenderFns } from "./CapitalSocial.vue?vue&type=template&id=5881c11c&"
import script from "./CapitalSocial.vue?vue&type=script&lang=ts&"
export * from "./CapitalSocial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports